<mat-menu #menuRemove="matMenu" class="mho-menu-remove {{class()}}">
    <ng-template matMenuContent let-menuLabel="menuLabel" let-list="list" let-emptyLabel="emptyLabel">
        <div class="search" (click)="$event.stopPropagation()">
            <mat-form-field subscriptSizing="dynamic" style="width: 100%">
                <mat-label>{{ menuLabel }}</mat-label>
                <input matInput #searchItem>
            </mat-form-field>
        </div>
        <!-- Un sac peut contenir plusieurs fois le même objet : suivi par position, pas par objet. -->
        <div class="items">
            @for (item of list; track $index) {
                @if (searchItem.value === '' || $any(item.label[$any(locale)] ? item.label[$any(locale)] : item.label).toLowerCase().indexOf(searchItem.value.toLowerCase()) > -1) {
                    <span class="tile" (click)="remove.emit(item.id)">
                        <img [ngSrc]="HORDES_IMG_REPO + item.img"
                             [title]="$any(item.label[$any(locale)] ? item.label[$any(locale)] : item.label)" width="16" height="16">
                    </span>
                }
            }
        </div>
        <div mat-menu-item class="empty-bag" (click)="empty.emit()">
            <img [ngSrc]="HORDES_IMG_REPO + 'icons/b_close.png'" style="margin-right: 0.5em" width="16" height="16">
            <span>{{ emptyLabel }}</span>
        </div>
    </ng-template>
</mat-menu>
